import { S as r, a as e, b as n, k as L, l as i, m as c, n as T, s as S, t as v, u as x, v as p, E as l, F as h, G as f, H as G, I as d, J as u, K as C, L as m, A as s, B as t, C as a, D as g, c as P, d as M, e as I, f as O, M as R, N as U, O as y, P as b, g as B, h as D, i as k, j as E, w as j, x as q, y as w, z, o as F, p as H, q as J, r as K, Q as N, R as Q, T as V, U as W, V as X, W as Y, X as _, Y as Z } from "../../MenuAdoptionCycleTextLight-D7UAF4ec.js";
var $ = /* @__PURE__ */ ((o) => (o.Snap = "snap", o.ReportPro = "report-pro", o.MenuTrends = "menutrends", o.ConsumerPreferences = "flavor", o.ConceptIdeation = "food-studio", o.LaunchesAndRatings = "scores", o.ConceptLocker = "scores-cl", o.LocalInsights = "local", o.BrandPerformance = "fingerprints", o.PriceMonitor = "price-monitor", o.Chains = "ff-chains", o.Operators = "firefly", o.GlobalOperators = "sales-intelligence", o.Mac = "mac", o))($ || {});
const oo = {
  snap: {
    appId: "snap",
    Logo: r,
    LogoGs: e,
    LogoText: e,
    LogoTextLight: n
  },
  "report-pro": {
    appId: "report-pro",
    Logo: L,
    LogoGs: i,
    LogoText: c,
    LogoTextLight: T
  },
  menutrends: {
    appId: "menutrends",
    Logo: S,
    LogoGs: v,
    LogoText: x,
    LogoTextLight: p
  },
  flavor: {
    appId: "flavor",
    Logo: l,
    LogoGs: h,
    LogoText: f,
    LogoTextLight: G
  },
  "food-studio": {
    appId: "food-studio",
    Logo: d,
    LogoGs: u,
    LogoText: C,
    LogoTextLight: m
  },
  scores: {
    appId: "scores",
    Logo: s,
    LogoGs: t,
    LogoText: a,
    LogoTextLight: g
  },
  "scores-cl": {
    appId: "scores-cl",
    Logo: s,
    LogoGs: t,
    LogoText: a,
    LogoTextLight: g
  },
  "ff-chains": {
    appId: "ff-chains",
    Logo: P,
    LogoGs: M,
    LogoText: I,
    LogoTextLight: O
  },
  fingerprints: {
    appId: "fingerprints",
    Logo: R,
    LogoGs: U,
    LogoText: y,
    LogoTextLight: b
  },
  firefly: {
    appId: "firefly",
    Logo: B,
    LogoGs: D,
    LogoText: k,
    LogoTextLight: E
  },
  local: {
    appId: "local",
    Logo: j,
    LogoGs: q,
    LogoText: w,
    LogoTextLight: z
  },
  "price-monitor": {
    appId: "price-monitor",
    Logo: F,
    LogoGs: H,
    LogoText: J,
    LogoTextLight: K
  },
  "sales-intelligence": {
    appId: "sales-intelligence",
    Logo: N,
    LogoGs: Q,
    LogoText: V,
    LogoTextLight: W
  },
  mac: {
    appId: "mac",
    Logo: X,
    LogoGs: Y,
    LogoText: _,
    LogoTextLight: Z
  }
};
export {
  oo as ALL_ITEMS,
  $ as AppId
};
